import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllOrders(page, limit, options) {
  return httpClient.get('/merchant/orders', {
    params: {
      page,
      limit,
      ...options,
    },
  });
}

/**
 *
 * @param orderId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getOrder(orderId) {
  return httpClient.get(`/merchant/orders/${orderId}`);
}

/**
 *
 * @param orderId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteOrder(orderId) {
  return httpClient.delete(`/merchant/orders/${orderId}`);
}

/**
 *
 * @param orderId
 * @param order
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateOrder(orderId, order) {
  return httpClient.put(`/merchant/orders/${orderId}`, order);
}

/**
 *
 * @param outlet
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newOrder(outlet) {
  return httpClient.post('/merchant/orders', outlet);
}

/**
 *
 * @param newRecord
 * @returns {Promise<AxiosResponse<T>> | void | IDBRequest<IDBValidKey> | Promise<void>}
 */
export function newOrderItem(newRecord) {
  return httpClient.post('/merchant/new-ordered-item', newRecord);
}

/**
 *
 * @param orderedItemId
 * @param updatedRecord
 * @returns {Promise<AxiosResponse<T>> | void | IDBRequest<IDBValidKey> | Promise<void>}
 */
export function updateOrderItem(orderedItemId, updatedRecord) {
  return httpClient.put(`/merchant/update-ordered-item/${orderedItemId}`, updatedRecord);
}

/**
 *
 * @param orderedItemId
 * @param updatedRecord
 * @returns {Promise<AxiosResponse<T>> | void | IDBRequest<IDBValidKey> | Promise<void>}
 */
export function deleteOrderItem(orderedItemId) {
  return httpClient.delete(`/merchant/delete-ordered-item/${orderedItemId}`);
}

// Merchant Specific APIs ends
// =========================================
